import { styled } from "../../../styled-components";

export const EmptyWrapperContainer = styled.div<{ forceDisplay: boolean }>`
    display: ${p => (p.forceDisplay ? "flex" : "none")};

    &:only-child {
        display: flex;
    }

    width: 100%;
    flex-grow: 1;

    justify-content: center;
    align-items: center;
    flex-direction: column;

    color: #bdbdbd;
    ${p => p.theme.fontStyles.AccentHeader2}
    text-align: center;

    @keyframes list-empty-fade-in {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    animation: 0.5s ease-in 0s 1 list-empty-fade-in;

    .emptyWrapperIcon {
        margin-bottom: 12px;

        & > *,
        & svg {
            width: 120px;
            height: 120px;
        }
    }
`;
